import { mapEnumToOptions } from '@abp/ng.core';

export enum ExternalSystemState {
  Inactive = 0,
  Active = 1,
}

export const externalSystemStateOptions = mapEnumToOptions(ExternalSystemState);
